import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Tick",
  "use": "icon-Tick-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-Tick\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.333 10A6.667 6.667 0 0 1 10 3.333a.833.833 0 1 0 0-1.667A8.333 8.333 0 1 0 18.333 10a.833.833 0 0 0-1.666 0 6.667 6.667 0 0 1-13.334 0Zm14-6.167a.833.833 0 0 0-1.333-1l-6.034 8.324L7.306 7.8a.833.833 0 0 0-1.28 1.067l2.66 3.357a1.667 1.667 0 0 0 2.613-.067l6.034-8.324Z\" fill=\"#4C556C\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol